module.exports = __webpack_public_path__ + "img/kevin2.9b3c179e.jpg";